/**
 * LOCATION: dashboard-business/src/pages/Login.js
 */
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import AuthService from '../services/auth';

const API_URL = 'https://janimony-backend.onrender.com/api';

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm]       = useState({ email: '', password: '' });
  const [showPw, setShowPw]   = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!document.getElementById('fa-login')) {
      const fa = document.createElement('link'); fa.id = 'fa-login'; fa.rel = 'stylesheet';
      fa.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css';
      document.head.appendChild(fa);
    }
    const em = sessionStorage.getItem('login_email');
    const ms = sessionStorage.getItem('login_message');
    if (em) { setForm(p => ({ ...p, email: em })); sessionStorage.removeItem('login_email'); }
    if (ms) { setSuccess(ms); sessionStorage.removeItem('login_message'); }
    if (!em && !ms && AuthService.isAuthenticated()) navigate('/dashboard');
  }, [navigate]);

  const handle = async (e) => {
    e.preventDefault(); setError(''); setSuccess(''); setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/auth/login`, form);
      if (res.data.success || res.data.token) {
        AuthService.setUser(res.data.business, res.data.token);
        navigate('/dashboard');
      } else setError('Invalid email or password');
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to connect to server');
    } finally { setLoading(false); }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500;600;700&display=swap');
        .bl-pg { min-height:100vh; background:linear-gradient(135deg,#0a0a0a 0%,#1a0533 55%,#0d1117 100%); display:flex; align-items:center; justify-content:center; padding:20px; font-family:'DM Sans',sans-serif; position:relative; overflow:hidden; }
        .bl-orb1 { position:fixed; width:500px; height:500px; border-radius:50%; background:radial-gradient(circle,rgba(102,126,234,0.15),transparent 70%); top:-180px; right:-80px; pointer-events:none; }
        .bl-orb2 { position:fixed; width:380px; height:380px; border-radius:50%; background:radial-gradient(circle,rgba(118,75,162,0.12),transparent 70%); bottom:-130px; left:-80px; pointer-events:none; }
        .bl-card { width:100%; max-width:420px; background:rgba(255,255,255,0.04); backdrop-filter:blur(20px); border:1px solid rgba(255,255,255,0.1); border-radius:24px; padding:44px 40px; position:relative; z-index:1; box-shadow:0 40px 80px rgba(0,0,0,0.5),inset 0 1px 0 rgba(255,255,255,0.08); }
        .bl-logo { display:flex; align-items:center; justify-content:center; gap:11px; margin-bottom:10px; }
        .bl-logo-icon { width:44px; height:44px; border-radius:14px; background:linear-gradient(135deg,#667eea,#764ba2); display:flex; align-items:center; justify-content:center; box-shadow:0 8px 20px rgba(102,126,234,0.4); }
        .bl-logo-text { font-family:'Syne',sans-serif; font-size:22px; font-weight:800; color:#fff; }
        .bl-feats { display:grid; grid-template-columns:1fr 1fr 1fr; gap:8px; margin:20px 0 28px; }
        .bl-feat { text-align:center; padding:10px 6px; background:rgba(255,255,255,0.03); border:1px solid rgba(255,255,255,0.07); border-radius:10px; }
        .bl-feat-lbl { font-size:10px; color:rgba(255,255,255,0.35); font-weight:600; margin-top:4px; }
        .bl-h1 { font-family:'Syne',sans-serif; font-size:26px; font-weight:800; color:#fff; text-align:center; margin-bottom:6px; }
        .bl-sub { font-size:13px; color:rgba(255,255,255,0.4); text-align:center; margin-bottom:28px; }
        .bl-alert { padding:12px 15px; border-radius:10px; font-size:13px; margin-bottom:18px; display:flex; align-items:flex-start; gap:8px; line-height:1.5; }
        .bl-err { background:rgba(239,68,68,0.12); border:1px solid rgba(239,68,68,0.3); color:#fca5a5; }
        .bl-ok  { background:rgba(16,185,129,0.12); border:1px solid rgba(16,185,129,0.3); color:#6ee7b7; }
        .bl-grp { margin-bottom:16px; }
        .bl-lbl { display:block; font-size:12px; font-weight:700; color:rgba(255,255,255,0.5); margin-bottom:7px; letter-spacing:0.4px; text-transform:uppercase; }
        .bl-wrap { position:relative; }
        .bl-inp { width:100%; padding:12px 14px 12px 40px; background:rgba(255,255,255,0.06); border:1px solid rgba(255,255,255,0.12); border-radius:12px; color:#fff; font-size:14px; outline:none; font-family:'DM Sans',sans-serif; transition:border-color 0.2s,background 0.2s; box-sizing:border-box; }
        .bl-inp::placeholder { color:rgba(255,255,255,0.22); }
        .bl-inp:focus { border-color:rgba(102,126,234,0.6); background:rgba(102,126,234,0.08); }
        .bl-ico { position:absolute; left:13px; top:50%; transform:translateY(-50%); color:rgba(255,255,255,0.3); font-size:13px; }
        .bl-eye { position:absolute; right:12px; top:50%; transform:translateY(-50%); background:transparent; border:none; cursor:pointer; color:rgba(255,255,255,0.3); font-size:14px; padding:3px; }
        .bl-forgot { display:block; text-align:right; font-size:12px; color:rgba(102,126,234,0.9); text-decoration:none; font-weight:600; margin:-8px 0 18px; }
        .bl-btn { width:100%; padding:13px; background:linear-gradient(135deg,#667eea,#764ba2); color:#fff; border:none; border-radius:12px; font-size:15px; font-weight:700; cursor:pointer; font-family:'DM Sans',sans-serif; display:flex; align-items:center; justify-content:center; gap:8px; box-shadow:0 8px 20px rgba(102,126,234,0.35); transition:transform 0.2s,box-shadow 0.2s; margin-bottom:20px; }
        .bl-btn:hover:not(:disabled) { transform:translateY(-1px); box-shadow:0 12px 28px rgba(102,126,234,0.45); }
        .bl-btn:disabled { opacity:0.65; cursor:not-allowed; }
        .bl-div { display:flex; align-items:center; gap:12px; margin-bottom:18px; }
        .bl-div-line { flex:1; height:1px; background:rgba(255,255,255,0.07); }
        .bl-div-txt { font-size:12px; color:rgba(255,255,255,0.22); }
        .bl-signup { text-align:center; font-size:13px; color:rgba(255,255,255,0.4); }
        .bl-signup a { color:#667eea; font-weight:700; text-decoration:none; }
        @media(max-width:480px){.bl-card{padding:32px 22px;border-radius:20px;}.bl-h1{font-size:22px;}}
      `}</style>
      <div className="bl-pg">
        <div className="bl-orb1" /><div className="bl-orb2" />
        <div className="bl-card">
      <div className="bl-logo">
 <img 
    src={`${process.env.PUBLIC_URL}/janimony-logo.png`} 
    alt="Janimony" 
    style={{ width: '100px', height: 'auto', objectFit: 'contain' }}
  />
</div>
          <div className="bl-feats">
            {[{icon:'fa-robot',color:'#667eea',label:'AI Chat'},{icon:'fa-users',color:'#10b981',label:'Live Agents'},{icon:'fa-globe',color:'#f59e0b',label:'Multilingual'}].map(f=>(
              <div className="bl-feat" key={f.label}>
                <i className={`fa-solid ${f.icon}`} style={{color:f.color,fontSize:16}}></i>
                <div className="bl-feat-lbl">{f.label}</div>
              </div>
            ))}
          </div>
          <h1 className="bl-h1">Welcome back</h1>
          <p className="bl-sub">Sign in to your business dashboard</p>
          {error   && <div className="bl-alert bl-err"><i className="fa-solid fa-circle-exclamation"></i>{error}</div>}
          {success && <div className="bl-alert bl-ok"><i className="fa-solid fa-circle-check"></i>{success}</div>}
          <form onSubmit={handle}>
            <div className="bl-grp">
              <label className="bl-lbl">Email Address</label>
              <div className="bl-wrap">
                <i className="fa-solid fa-envelope bl-ico"></i>
                <input className="bl-inp" type="email" placeholder="you@company.com" value={form.email}
                  onChange={e=>{setForm({...form,email:e.target.value});setError('');}} required autoComplete="email"/>
              </div>
            </div>
            <div className="bl-grp">
              <label className="bl-lbl">Password</label>
              <div className="bl-wrap">
                <i className="fa-solid fa-lock bl-ico"></i>
                <input className="bl-inp" type={showPw?'text':'password'} placeholder="Enter your password"
                  value={form.password} style={{paddingRight:40}}
                  onChange={e=>{setForm({...form,password:e.target.value});setError('');}} required autoComplete="current-password"/>
                <button type="button" className="bl-eye" onClick={()=>setShowPw(!showPw)}>
                  <i className={`fa-solid ${showPw?'fa-eye-slash':'fa-eye'}`}></i>
                </button>
              </div>
            </div>
            <Link to="/forgot-password" className="bl-forgot">Forgot password?</Link>
            <button type="submit" className="bl-btn" disabled={loading}>
              {loading?<><i className="fa-solid fa-spinner fa-spin"></i>Signing in...</>:<><i className="fa-solid fa-right-to-bracket"></i>Sign In</>}
            </button>
          </form>
          <div className="bl-div"><div className="bl-div-line"/><span className="bl-div-txt">New here?</span><div className="bl-div-line"/></div>
          <p className="bl-signup">Don't have an account? <Link to="/signup">Create One</Link></p>
        </div>
      </div>
    </>
  );
}